export interface SwayyOrder {
  id: number;
  user_id: number;
  channel: string;
  uuid: string;
  order_number: string;
  status: string;
  payment_status: string;
  grand_total: number;
  currency: string;
  placed_at: string;
  thumbnail_url: string | null;
  items: SwayyOrderListItem[];
  payment_method: string;
  customer: SwayyOrderCustomer;
}

export interface SwayyOrderListItem {
  id: number;
  variant_id: number;
  product_id: number;
  sku: string;
  name: string;
  variant_label: string;
  attributes?: Record<string, string>;
  image_url?: string | null;
  hsn_code?: string;
  tax_rate?: number;
  mrp?: number;
  unit_price: number;
  qty: number;
  line_subtotal: number;
  line_tax: number;
  line_total: number;
  qty_shipped?: number;
}

export interface SwayyOrderCustomer {
  email: string;
  phone: string;
  first_name: string;
  last_name: string;
}

export interface SwayyOrdersPagination {
  total: number;
  page: number;
  limit: number;
}

export interface SwayyOrdersListData {
  orders: SwayyOrder[];
  pagination: SwayyOrdersPagination;
}

export interface GetSwayyOrdersParams {
  page: number;
  limit: number;
  q?: string;
  status?: string;
  payment_status?: string;
  channel?: string;
  sort_by?: string;
  sort_order?: "asc" | "desc";
  start_date?: string;
  end_date?: string;
}


export interface CancelSwayyOrderRefund {
  amount: number;
  status: string;
  eta: string;
}

export interface CancelSwayyOrderResult {
  uuid: string;
  status: string;
  refund?: CancelSwayyOrderRefund | null;
}

export interface CreateSwayyOrderNotePayload {
  note: string;
  image_urls?: string[];
}

export interface UpdateSwayyOrderNotePayload {
  note?: string;
  image_urls?: string[];
}

export const getSwayyCustomerName = (
  customer?: SwayyOrderCustomer | null,
): string => {
  if (!customer) return "—";
  const name = [customer.first_name, customer.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  return name || customer.email || customer.phone || "—";
};

export const getSwayyCustomerContact = (
  customer?: SwayyOrderCustomer | null,
): string => {
  if (!customer) return "—";
  return customer.email || customer.phone || "—";
};
